import { Controller } from 'stimulus'
import { useBusItem } from '../mixins/useBusItem.js'
import { useDispatch, useDebounce } from 'stimulus-use'

import * as Loadash from 'lodash'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['bulkButton', 'loadMoreButton', 'exportButton', 'clearAllButton']
  static debounces = ['loadResults']

  static values = {
    busItemId: String,
    continuationToken: String
  }

  connect() {
    useDebounce(this, { wait: 1000 })
    useBusItem(this)
    useDispatch(this)

    this.loadResults()
  }

  disconnect() {
    this.removeFromBus()
  }

  continuationTokenValueChanged() {
    setTimeout(() => {
      if (this.hasContinuationTokenValue && this.continuationTokenValue !== '') {
        this.loadMoreButtonTarget.classList.remove('hidden')
      } else {
        this.loadMoreButtonTarget.classList.add('hidden')
      }
    }, 0)
  }

  // Call this method when any of the search data in the page changed
  onSearchDataUpdated() {
    this.loadResults()
  }

  loadResults() {
    const urlParams = this.getCurrentSearchParamsFromURL().search_attributes

    setTimeout(() => {
      this.reloadCards()
      this.dispatch('searchTriggered', { params: $.param(urlParams).concat('', '&content_type[]=directory') })
    }, 0)
  }

  reloadCards() {
    this.continuationTokenValue = ''
    const cardsLoader = this.getBusItem('cards-loader')
    const searchAttributes = this.searchAttributes

    Rails.ajax({
      type: 'GET',
      url: '/directories/active_filters',
      dataType: 'script',
      data: $.param(searchAttributes.search_attributes)
    })

    cardsLoader.dataValue = searchAttributes

    cardsLoader.load()

    const iframeConnection = this.getBusItem('iframe-connection')
    iframeConnection.updateRailsUrl({ detail: { searchParams: searchAttributes } })
    this.disableClearAllButton()
  }

  loadMoreCards() {
    const cardsLoader = this.getBusItem('cards-loader')
    const searchAttributes = this.searchAttributes
    cardsLoader.dataValue = searchAttributes
    this.continuationTokenValue = undefined

    cardsLoader.loadAdjacent()
  }

  get searchAttributes() {
    const quantityData = this.getBusItem('quantity').inputsData
    const generalData = this.getBusItem('general-data').inputsData
    const orderByData = this.getBusItem('sort-order').inputsData
    const continuationTokenData = { search_attributes: { continuation_token: this.continuationTokenValue } }

    return Loadash.merge({}, generalData, quantityData, orderByData, continuationTokenData)
  }

  addLabels() {
    this.addTags('labels-tags')
  }

  addIssues() {
    this.addTags('issues-tags')
  }

  addTags(busItemId) {
    const entitiesIds = this.getSelectedEntitiesIds()
    const tagsController = this.getBusItem(busItemId)
    tagsController.entityIdsValue = entitiesIds
    tagsController.triggerAddTags()
  }

  getSelectedEntitiesIds() {
    const entitySelector = this.getBusItem('cards-selector')
    const checkedList = entitySelector.checkboxesList.checkedList
    const entitiesIds = []

    for (const key in checkedList) {
      if (Object.hasOwnProperty.call(checkedList, key)) {
        entitiesIds.push(checkedList[key].item.value)
      }
    }

    return entitiesIds
  }

  setContinuationToken(event) {
    const newValue = event.detail[Object.keys(event.detail)[0]]
    this.continuationTokenValue = newValue
  }

  handleExportActions() {
    this.setExportEntityIds()
    this.setExportSearchAttributes()
  }

  setExportSearchAttributes() {
    const exportController = this.getBusItem('export-generator')
    const searchParams = $('#directory-filter-form').serialize()
    exportController.searchAttributesValue = searchParams
  }

  setExportEntityIds() {
    const exportController = this.getBusItem('export-generator')
    exportController.entityIdsValue = this.getSelectedEntitiesIds()
  }

  getCurrentSearchParamsFromURL() {
    const { search } = new URL(window.location.href)
    return $.deparam(search.substr(1))
  }

  disableClearAllButton() {
    const baseObject = {
      search_text: "",
      labels_logical_operator: "Any",
      issues_logical_operator: "Any",
      size: "25",
      sort_order: "ASC",
      continuation_token: ""
    };

    var searchAttributes = this.getCurrentSearchParamsFromURL();

    if(jQuery.isEmptyObject(searchAttributes)) {
      this.clearAllButtonTarget.disabled = true;
      this.clearAllButtonTarget.classList.add('hidden');
      return true;
    }

    this.clearAllButtonTarget.disabled = _.isEqual(search_attributes['search_attributes'], baseObject);
  }
}
